import type { SectionVisual } from '../../../components/ui/sectionCard/types';
import {
  Person as PersonIcon,
  LocationOn as LocationOnIcon,
  Phone as PhoneIcon,
  Warning as WarningIcon,
  CreditCard as CreditCardIcon,
  People as PeopleIcon,
  EventNote as EventNoteIcon,
  VpnKey as VpnKeyIcon,
  AccountBalance as AccountBalanceIcon,
  Notes as NotesIcon,
} from '@mui/icons-material';
import { alpha } from '@mui/material/styles';
import theme from '../../../theme/theme';

// ── Page background ─────────────────────────────────────────────────────────────

export const PAGE_BG = theme.palette.common.white;

// ── Sub-header ──────────────────────────────────────────────────────────────────

export const SUB_HEADER = {
  gradient: alpha(theme.palette.primary.main, 0.06),
  color: theme.palette.text.body,
  buttonColor: theme.palette.primary.main,
};

// ── Navigation tabs ─────────────────────────────────────────────────────────────

export const NAV_TABS = {
  bg: theme.palette.common.white,
  border: `1px solid ${theme.palette.divider}`,
  shadow: theme.shadows[1],
  indicatorColor: theme.palette.primary.main,
  activeColor: theme.palette.primary.main,
  inactiveColor: theme.palette.text.label,
  hoverColor: theme.palette.text.body,
};

// ── Section cards ───────────────────────────────────────────────────────────────

export type SectionKey =
  | 'personal'
  | 'address'
  | 'contact'
  | 'emergency'
  | 'documents'
  | 'dependents'
  | 'death'
  | 'pins'
  | 'payment'
  | 'comment';

export const SECTION_VISUAL: Record<SectionKey, SectionVisual> = {
  personal:   { iconBg: '#dbeafe', iconColor: '#2563eb' },
  address:    { iconBg: '#d1fae5', iconColor: '#059669' },
  contact:    { iconBg: '#e9d5ff', iconColor: '#9333ea' },
  emergency:  { iconBg: '#fed7aa', iconColor: '#ea580c' },
  documents:  { iconBg: '#c7d2fe', iconColor: '#4f46e5' },
  dependents: { iconBg: '#fce7f3', iconColor: '#e11d48' },
  death:      { iconBg: '#f3f4f6', iconColor: '#374151' },
  pins:       { iconBg: '#fef9c3', iconColor: '#a16207' },
  payment:    { iconBg: '#dcfce7', iconColor: '#15803d' },
  comment:    { iconBg: '#f0f9ff', iconColor: '#0369a1' },
};

export const SECTION_ICON: Record<SectionKey, (color: string) => ReturnType<typeof PersonIcon>> = {
  personal:   c => <PersonIcon         sx={{ fontSize: 20, color: c }} />,
  address:    c => <LocationOnIcon     sx={{ fontSize: 20, color: c }} />,
  contact:    c => <PhoneIcon          sx={{ fontSize: 20, color: c }} />,
  emergency:  c => <WarningIcon        sx={{ fontSize: 20, color: c }} />,
  documents:  c => <CreditCardIcon     sx={{ fontSize: 20, color: c }} />,
  dependents: c => <PeopleIcon         sx={{ fontSize: 20, color: c }} />,
  death:      c => <EventNoteIcon      sx={{ fontSize: 20, color: c }} />,
  pins:       c => <VpnKeyIcon         sx={{ fontSize: 20, color: c }} />,
  payment:    c => <AccountBalanceIcon sx={{ fontSize: 20, color: c }} />,
  comment:    c => <NotesIcon          sx={{ fontSize: 20, color: c }} />,
};
